import type { Status } from '@contracts/quickbooks/QuickbooksIntegrationContract';
import Link from '@mui/icons-material/Link';
import LinkOff from '@mui/icons-material/LinkOff';
import { Button } from '@src/common/components/button/Button';
import { LoadingSpinner } from '@src/common/components/LoadingSpinner';
import { useQuickbooksDisconnect } from '@src/quickbooks/hooks/useQuickbooksDisconnect';
import { QuickbooksSettingsClient } from '@src/quickbooks/services/QuickbooksSettingsClient';
import { useTranslation } from 'react-i18next';

interface Props {
  status?: Status;
}

export const QuickbooksButton = ({ status }: Props) => {
  const { t } = useTranslation();
  const { disconnect, loading } = useQuickbooksDisconnect();

  const connectionAction = async () => {
    const { redirectUri } = await QuickbooksSettingsClient.getRedirectUri();
    window.open(redirectUri);
  };

  const Connect = (
    <Button onClick={connectionAction} variant="contained" startIcon={<Link />}>
      {t('integrations.connect')}
    </Button>
  );

  const Disconnect = loading ? (
    <Button variant="outlined" fullWidth={true}>
      <LoadingSpinner sizeInPx={20} />
    </Button>
  ) : (
    <Button
      onClick={() => disconnect()}
      variant="outlined"
      startIcon={<LinkOff />}
      fullWidth={true}
    >
      {t('integrations.disconnect')}
    </Button>
  );

  return status === 'active' ? Disconnect : Connect;
};
